var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.523438 3.15625C0.523438 1.77554 1.64273 0.65625 3.02344 0.65625H17.0249C18.4056 0.65625 19.5249 1.77554 19.5249 3.15625V17.1562C19.5249 18.537 18.4056 19.6562 17.0249 19.6562H3.02344C1.64273 19.6562 0.523438 18.537 0.523438 17.1562V3.15625Z",
    fill: "white",
    stroke: "#BEBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckIcon);
export default __webpack_public_path__ + "static/media/uncheck_icon.4c51505cf241e2e5ae7faa905656a3cd.svg";
export { ForwardRef as ReactComponent };